export const PROPERTY = (communityId: string) => `/v1/community/${communityId}/properties`;
export const PROPERTY_OCCUPANCY_LIST_API = (propertyId: string) =>
  `v1/property-occupancy/${propertyId}`;
export const PROPERTY_OCCUPANCY_LIST_BY_COMMUNITY_API = (communityId: string) =>
  `v1/property-occupancy/by-community/${communityId}`;
export const DOWNLOAD_PROPERTY_TEMPLATE = `v1/onboarding/properties`
export const ONBOARDING_API = (communityId: string) => `v1/onboarding/community/${communityId}`